"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable max-len */

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    cls1: {
      fill: theme.palette.primary.main
    },
    cls2: {
      fill: theme.palette.secondary.mainDark
    }
  };
});
var WobiLogo = function WobiLogo() {
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "66.01",
    height: "41.471",
    viewBox: "0 0 105.503 41.471"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(-0.004 0.066)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(0.004 -0.067)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    className: classes.cls1,
    d: "M206.8,0a4.936,4.936,0,0,1,5.021,5.021,5.021,5.021,0,1,1-10.043,0A4.936,4.936,0,0,1,206.8,0",
    transform: "translate(-106.318 0.033)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: classes.cls2,
    d: "M105.292,16.5a4.807,4.807,0,1,0-9.613,0V23.78a14.751,14.751,0,0,0-14.22-12.132,13.686,13.686,0,0,0-4.838.889c0-4.277,0-7.754,0-7.759a4.807,4.807,0,0,0-9.613,0V18.813a14.368,14.368,0,0,0-24.919-.04V4.78a4.807,4.807,0,1,0-9.614,0c0,.058-.009,23.979-.009,24.094a3.316,3.316,0,1,1-6.617,0V4.764a4.806,4.806,0,1,0-9.612-.051V28.874a3.431,3.431,0,0,1-3.308,3.542,3.431,3.431,0,0,1-3.309-3.542V4.78A4.807,4.807,0,1,0,0,4.78c0,.057.007,24.541.007,24.541C.012,35.944,4.1,41.4,12.592,41.4c3.256,0,6.623-1.1,8.442-3.752C22.856,40.3,26.266,41.4,29.521,41.4c6.774,0,10.729-3.472,12.056-8.232a14.828,14.828,0,0,0,12.957,8.1A14.885,14.885,0,0,0,68.1,31.83a14.359,14.359,0,0,0,27.576-2.958v6.921a4.807,4.807,0,1,0,9.614,0C105.293,35.774,105.292,16.51,105.292,16.5ZM54.547,31.775H54.52a5.135,5.135,0,0,1-5.015-5.348,5.744,5.744,0,0,1,.041-.678l.008-.024v-.042a5.068,5.068,0,0,1,4.954-4.6h.037a5.134,5.134,0,0,1,5.015,5.346A5.136,5.136,0,0,1,54.547,31.775Zm26.911-.1h-.027a5.135,5.135,0,0,1-5.015-5.349,5.838,5.838,0,0,1,.041-.677l.008-.024v-.042a5.068,5.068,0,0,1,4.954-4.6h.037a5.135,5.135,0,0,1,5.015,5.346A5.137,5.137,0,0,1,81.458,31.674Z",
    transform: "translate(-0.004 0.067)"
  }))));
};
var _default = exports.default = WobiLogo;